import { render, staticRenderFns } from "./AttachmentBox.vue?vue&type=template&id=54ca4420&scoped=true&"
import script from "./AttachmentBox.vue?vue&type=script&lang=ts&"
export * from "./AttachmentBox.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentBox.vue?vue&type=style&index=0&id=54ca4420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ca4420",
  null
  
)

export default component.exports